const EReasonRequest = {
  LOCALIZING_MATERIALS: 'entity.specialrequest.reasons.localizingmaterials',
  ON_BOARD_EQUIPMENT_INSIDE_VEHICULE: 'entity.specialrequest.reasons.materialsinvehicle',
  DEFAULT: ''
}

export default EReasonRequest;
